import React from 'react'

/**
  * @class Intro
  * Animation on introduction
  * Visible only on the first visit (no matter the route)
*/
class Intro extends React.Component {

  render() {
    return <section className="intro bg--green center-text">
      <img src="/images/logos/cosmic.png" alt="Cosmic - Altavia Group" />
      <div className="cache bg--white"></div>
      <div className="flash"></div>
      <div className="bar bar--white"></div>
      <div className="bar bar--black"></div>
    </section>
  }
}

/*
  TODO :
  Use transitions with react router ?
*/

export default Intro






// WEBPACK FOOTER //
// ./src/components/Intro.jsx